import type { WorldSavedGameSummary } from "@dawn/adapters";

export function formatSavedGameSummary(
  template: string,
  summary: WorldSavedGameSummary,
): string {
  return template
    .replace("{turn}", String(summary.turn))
    .replace("{population}", String(summary.population));
}
